import loadable from '@loadable/component';

export const PcgamerSiteWrapper = loadable(
  () => import(/* webpackChunkName: "pcgamer-site" */ './PcgamerSiteWrapper'),
);
